import React from 'react';
import PropTypes from 'prop-types';

/**
 * React component that renders chart label component. Chart label appears
 * below the highchart component and has the start and end dateranges.
 * @param {Bool} val - Properties used to render the component.
 * @returns {Element} React element.
 */
export class ChartLabel extends React.PureComponent {
  generateStyle = val => ({
    visibility: val ? 'visible' : 'hidden',
  });

  render() {
    this.startLabelRef = React.createRef();
    this.endLabelRef = React.createRef();
    return (
      <div className="chart-label" >
        <div className="primary-daterange">
          <div
            className="primary-start-date"
            ref={this.startLabelRef}
            style={this.generateStyle(this.props.isShowStartDateLabel)}
          >
            {this.props.chartLabelData.primaryStartDate}
          </div>
          <div
            className="primary-end-date"
            ref={this.endLabelRef}
            style={this.generateStyle(this.props.isShowEndDateLabel)}
          >
            {this.props.chartLabelData.primaryEndDate}
          </div>
        </div>
        { (this.props.isPopEnabled) &&
          <div className="comparison-daterange">
            <div
              className="comparison-start-date"
              style={this.generateStyle(this.props.isShowStartDateLabel)}
            >
              {this.props.chartLabelData.comparisonStartDate}
            </div>
            <div
              className="comparison-end-date"
              style={this.generateStyle(this.props.isShowEndDateLabel)}
            >
              {this.props.chartLabelData.comparisonEndDate}
            </div>
          </div>
        }
      </div>
    );
  }
}

ChartLabel.propTypes = {
  /** Pop daterange is enabled/disabled */
  isPopEnabled: PropTypes.bool.isRequired,

  /**
   * Chart label parameters showing the start and end date for
   * primary metric series and comparison series.
   */
  chartLabelData: PropTypes.shape({
    primaryStartDate: PropTypes.string,
    primaryEndDate: PropTypes.string,
    comparisonStartDate: PropTypes.string,
    comparisonEndDate: PropTypes.string,
  }).isRequired,
  isShowStartDateLabel: PropTypes.bool.isRequired,
  isShowEndDateLabel: PropTypes.bool.isRequired,
};
